
export function getAppConfigurationKey(key) {

    const config = JSON.parse(localStorage.getItem("configuration"));
    let value = config.find(x => x.key === key).value;

    return value === undefined ? '' : value;
}